import { useEffect, useState } from 'react';

// should always be the case on modern browsers
const hasIntersectionObserver: boolean =
  'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype;

export function useWhenVisible<T extends Element>(alwaysVisible: boolean): [(el: T) => void, boolean] {
  const [ref, setRef] = useState<T>();
  const [isVisible, setIsVisible] = useState<boolean>(alwaysVisible || !hasIntersectionObserver);

  useEffect(() => {
    // it's just done once :
    if (ref == null || isVisible) {
      return undefined;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    });

    observer.observe(ref);
    return () => {
      observer.disconnect();
    };
  }, [setIsVisible, ref, isVisible]);

  return [setRef, isVisible];
}
